import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaHome, FaCalendarCheck, FaChartBar, FaBookOpen, FaBullhorn, FaClock, FaUser, FaBook } from 'react-icons/fa';
import LearnerDashboard  from './Dashboard';
import LearnerAnalytics  from './Analytics';
import LearnerAttendance from './Attendance';
import LearnerMarks      from './Marks';
import LearnerMaterials  from './Materials';
import LearnerNotices    from './Notices';
import LearnerTimetable  from './Timetable';
import LearnerProfile    from './Profile';
import LearnerSubjects   from './Subjects';

const navItems = [
  { type:'section', label:'Overview' },
  { to:'/learner',             label:'Dashboard',       icon:FaHome },
  { to:'/learner/analytics',   label:'My Performance',  icon:FaChartBar },
  { type:'section', label:'My Learning' },
  { to:'/learner/subjects',    label:'My Subjects',     icon:FaBook },
  { to:'/learner/timetable',   label:'Timetable',       icon:FaClock },
  { to:'/learner/marks',       label:'My Marks',        icon:FaChartBar },
  { to:'/learner/materials',   label:'Study Materials', icon:FaBookOpen },
  { to:'/learner/attendance',  label:'My Attendance',   icon:FaCalendarCheck },
  { type:'section', label:'Communication' },
  { to:'/learner/notices',     label:'Notices',         icon:FaBullhorn },
  { type:'section', label:'Account' },
  { to:'/learner/profile',     label:'My Profile',      icon:FaUser },
];

export default function LearnerApp() {
  return (
    <DashboardLayout sidebarItems={navItems}>
      <Routes>
        <Route index               element={<LearnerDashboard />} />
        <Route path="analytics"    element={<LearnerAnalytics />} />
        <Route path="subjects"     element={<LearnerSubjects />} />
        <Route path="attendance"   element={<LearnerAttendance />} />
        <Route path="marks"        element={<LearnerMarks />} />
        <Route path="materials"    element={<LearnerMaterials />} />
        <Route path="notices"      element={<LearnerNotices />} />
        <Route path="timetable"    element={<LearnerTimetable />} />
        <Route path="profile"      element={<LearnerProfile />} />
        <Route path="*"            element={<Navigate to="/learner" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
